import Interval from "utility/Interval";

import sortIntervals from "./sortIntervals";

const lt = <T>(a: undefined | null | T, b: undefined | null | T, m: "l" | "g") => {
	if (a === undefined || a === null) {
		return m !== "g" && b !== undefined && b !== null;
	}

	return b !== undefined && b !== null && a < b;
};

const mergeIntervals = <T>(intervals: Interval<T>[]): Interval<T>[] => {
	if (intervals.length < 2) {
		return intervals;
	}

	const sorted = sortIntervals(intervals);

	const merged: [undefined | null | T, undefined | null | T][] = [];
	let last = merged[0];

	for (const interval of sorted) {
		if (last === undefined || lt(last[1], interval[0], "g")) {
			last = interval;
			merged.push(last);
		} else if (lt(last[1], interval[1], "l")) {
			// eslint-disable-next-line prefer-destructuring
			last[1] = interval[1];
		}
	}

	return merged;
};

export default mergeIntervals;
